import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";
import { WORKSPACES_KEY } from "../api/hooks/useWorkspaces";
import { workspaceKey } from "../api/hooks/useWorkspace";

export function useDeleteWorkspace(slug: string) {
  const qc = useQueryClient();
  return useMutation<void, ApiError, void>({
    mutationFn: () =>
      apiFetch<void>(`/api/ws/${slug}`, { method: "DELETE" }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: WORKSPACES_KEY });
      qc.removeQueries({ queryKey: workspaceKey(slug) });
    },
  });
}
